import * as React from 'react';
import {classNames} from '@shopify/react-utilities/styles';
import {autobind} from '@shopify/javascript-utilities/decorators';
import {RichIcon} from 'components/UIKit/Icon';
import {Link} from 'components/UIKit/Link';
import {CheckBox} from 'components/UIKit/CheckBox';
import {BaseModal, OnAfterOpen, OnClose} from 'components/BaseModal';
import icons from './images';

export interface ContentProps {
  facebookCta: string;
  facebookPath: string;
  googleCta: string;
  googlePath: string;
  header: string;
  mode: string;
  signupCTA: string;
  signupLegalCopy: string;
  signupLegalCopyLinkText: string;
}

const TERMS_LINK = 'https://exchangemarketplace.com/legal/terms';
const SUBSCRIBE_TEXT = 'Send me top listings and other updates. Unsubscribe anytime.';

export interface Props extends ContentProps {
  active?: boolean;
  buttonClassNames?: string[];
  modalClassNames?: string[];
  onAfterOpen?: OnAfterOpen;
  onClose?: OnClose;
  openByDefault?: boolean;
}

export interface State {
  subscribe: boolean;
}

export class SignUpModal extends React.PureComponent<Props, State> {
  baseModal: any;

  state = {
    subscribe: false,
  };

  @autobind
  handleFacebookClick() {
    const {facebookPath} = this.props;
    const {subscribe} = this.state;

    window.location.assign(`${facebookPath}?subscribe=${subscribe}`);
  }

  @autobind
  handleGoogleClick() {
    const {googlePath} = this.props;
    const {subscribe} = this.state;

    window.location.assign(`${googlePath}?subscribe=${subscribe}`);
  }

  @autobind
  openModal() {
    this.baseModal.openModal();
  }

  handleSubscribeChange = (event) => {
    this.setState({
      subscribe: Boolean(event.target.checked),
    });
  };

  render() {
    const {
      active,
      buttonClassNames,
      facebookCta,
      googleCta,
      header,
      modalClassNames,
      mode,
      onAfterOpen,
      onClose,
      openByDefault,
      signupLegalCopy,
      signupLegalCopyLinkText,
      signupCTA,
    } = this.props;

    const baseModalProps = {
      active,
      buttonClassNames,
      label: header,
      modalClassNames: ['ui-sign-up-modal', ...(modalClassNames || [])],
      onAfterOpen,
      onClose,
      openByDefault,
      ref: (ref) => { this.baseModal = ref; },
    };

    return (
      <BaseModal {...baseModalProps}>
        <div>
          <div className="ui-sign-up-modal__header">
              <div className="ui-sign-up-modal__header-content">
                <h2>{header}</h2>
                <p>{mode === 'signup' && (<span>{signupCTA}</span>)}</p>
              </div>
          </div>
          <div className="ui-sign-up-modal__content">
            <div className="ui-sign-up-modal__section">
              <button
                className={classNames('marketing-button', 'ui-sign-up-modal__button', 'ui-sign-up-modal__button--google')}
                onClick={this.handleGoogleClick}
                type="button"
              >
                <RichIcon
                  alt={googleCta}
                  source={icons.google}
                  className="ui-sign-up-modal__button-icon"
                />
                {googleCta}
              </button>
            </div>

            <div className="ui-sign-up-modal__section">
              <button
                className={classNames('marketing-button', 'ui-sign-up-modal__button', 'ui-sign-up-modal__button--facebook')}
                onClick={this.handleFacebookClick}
                type="button"
              >
                <RichIcon
                  alt={facebookCta}
                  source={icons.facebook}
                  className="ui-sign-up-modal__button-icon"
                />
                {facebookCta}
              </button>
            </div>

            <div className="ui-sign-up-modal__section">
              <CheckBox
                name="subscribe"
                label={SUBSCRIBE_TEXT}
                onChange={this.handleSubscribeChange}
              />
            </div>

            <div className="ui-sign-up-modal__section ui-sign-up-modal__section--legal">
              <small>
                {signupLegalCopy}&nbsp;
                <Link
                  rel="noopener noreferrer"
                  url={TERMS_LINK}
                  text={signupLegalCopyLinkText}
                  newTab
                />
              </small>
            </div>

          </div>
        </div>
      </BaseModal>
    );
  }
}

export default SignUpModal;
